var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalletIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 5.5H1M1 9.5H4.54668C5.08687 9.5 5.35696 9.5 5.61813 9.54655C5.84995 9.58788 6.0761 9.65635 6.29191 9.75056C6.53504 9.85669 6.75977 10.0065 7.20924 10.3062L7.79076 10.6938C8.24023 10.9935 8.46496 11.1433 8.70809 11.2494C8.9239 11.3437 9.15005 11.4121 9.38186 11.4534C9.64304 11.5 9.91313 11.5 10.4533 11.5H11.5467C12.0869 11.5 12.357 11.5 12.6181 11.4534C12.85 11.4121 13.0761 11.3437 13.2919 11.2494C13.535 11.1433 13.7598 10.9935 14.2092 10.6938L14.7908 10.3062C15.2402 10.0065 15.465 9.85669 15.7081 9.75056C15.9239 9.65635 16.15 9.58788 16.3819 9.54655C16.643 9.5 16.9131 9.5 17.4533 9.5H21M1 4.2L1 13.8C1 14.9201 1 15.4802 1.21799 15.908C1.40973 16.2843 1.71569 16.5903 2.09202 16.782C2.51984 17 3.07989 17 4.2 17L17.8 17C18.9201 17 19.4802 17 19.908 16.782C20.2843 16.5903 20.5903 16.2843 20.782 15.908C21 15.4802 21 14.9201 21 13.8V4.2C21 3.0799 21 2.51984 20.782 2.09202C20.5903 1.7157 20.2843 1.40974 19.908 1.21799C19.4802 1 18.9201 1 17.8 1L4.2 1C3.0799 1 2.51984 1 2.09202 1.21799C1.7157 1.40973 1.40973 1.71569 1.21799 2.09202C1 2.51984 1 3.07989 1 4.2Z",
    stroke: "#3D9F4A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletIcon);
export default __webpack_public_path__ + "static/media/wallet-icon.6537b428cd33cbe90f4c9b1c5238a9c7.svg";
export { ForwardRef as ReactComponent };